import { cardCoverImageResource } from '@jira/project-settings__board-settings-card/src/cardCoverImageResource.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareBoardsCardRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareBoardsCardRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import Card, {
	LazyCard,
} from './ui/project-settings/product-routes/software/board-settings/card/index.tsx';
import { BoardCardSettingsRedirectToBoardView } from './ui/index.tsx';

export const projectSettingsSoftwareBoardsCardRouteEntry: Route = createEntry(
	projectSettingsSoftwareBoardsCardRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
		// eslint-disable-next-line no-restricted-syntax
		component: fg('cover_image_issue_view_ga') ? BoardCardSettingsRedirectToBoardView : Card,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources(), cardCoverImageResource],
		forPaint: [LazyAtlassianNavigation, LazyCard],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
